import "./HowToChooseCheckeredPlate.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import GuideHero from "./sections/GuideHero";
import GuideSteps from "./sections/GuideSteps";
import GuideCta from "./sections/GuideCta";
export default function HowToChooseCheckeredPlatePage() {
  return <div>
      <Header />
      <GuideHero />
      <GuideSteps />
      <GuideCta />
      <Footer />
    </div>;
}